'use client'

import { Box, SimpleGrid, VStack } from '@chakra-ui/react'
import { ContentContainer } from 'ui'
import { FC } from 'react'
import { SectionLabel, SectionTitle, StoryCard } from '../_components/granditude'
import { Text } from '@chakra-ui/react'

const stories = [
  {
    tools: ['Shopify', 'Fortnox', 'Zettle'],
    title: '"Everything was syncing, nothing was working"',
    problem:
      'Three systems, all supposedly integrated — inventory wrong, invoices chaos, bookkeeping a mess. They spent more time fixing errors than running the business.',
    outcome: 'Proper integration, real-time stock sync, one source of truth.',
    href: '/what-we-do#everything-syncing'
  },
  {
    tools: ['Visma', 'Wikinggruppen', 'B2B'],
    title: '"Locked inside their own tools"',
    problem:
      'B2B company stuck on Visma and Wikinggruppen. Slow workflows, limited ordering options, customers still ordering by email and PDF catalogs. They felt trapped.',
    outcome: 'They use our storefront to sell B2B using right price lists.',
    href: '/what-we-do#locked-tools'
  },
  {
    tools: ['Magento', 'Multi-site', 'International'],
    title: '"Big platform, bigger mess"',
    problem:
      'Multi-site Magento setup. Product catalog chaos, every new market expansion a 6-month project. The platform was powerful but working against them.',
    outcome:
      'New markets in weeks, not months. Now building a custom app to enhance brand awareness.',
    href: '/what-we-do#big-platform'
  }
]

export const StoriesSection: FC = () => {
  return (
    <Box as="section" w="100%" py={{ base: 16, md: 32 }}>
      <ContentContainer>
        <VStack align="start" spacing={0} w="100%">
          <SectionLabel>Problems We&apos;ve Solved</SectionLabel>
          <SectionTitle>Some messes we&apos;ve fixed</SectionTitle>
          <Text fontSize="1.1rem" color="text.secondary" maxW="600px" mb={10}>
            Every business has its own chaos. Here&apos;s how we&apos;ve helped companies like
            yours.
          </Text>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10} w="100%">
            {stories.map((story, index) => (
              <StoryCard key={index} {...story} />
            ))}
          </SimpleGrid>
        </VStack>
      </ContentContainer>
    </Box>
  )
}
